export default {
  'menu.blocks': '定义区块',
  'menu.general-content': '编辑通用区块',
  'menu.section-content': '编辑文案区块',
  'menu.section-content.am': '澳门',
  'menu.section-content.xg': '香港',
  'menu.posts': '编辑帖子',
  'menu.posts.am': '澳门',
  'menu.posts.xg': '香港',
  'menu.ads': '广告区块管理',
  'menu.site-setting': '站点配置',
  'menu.site-setting.basic': '基本配置',
  'menu.site-setting.recommendations': '好站推荐链接',
  'menu.site-setting.gallery-detail-ads': '图库页广告',
  'menu.site-setting.lottery-records': '开奖记录',
  'menu.more-blocks': '更多区块',
  'menu.admin-users': '后台用户管理',
  'menu.frontend-users': '图库用户管理',
  'menu.user-posts': '用户帖子管理',
  'menu.user-comments': '用户评论管理',
  'menu.change-password': '修改密码',
  'menu.setup-2fa': '绑定验证器',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
